import { Cookies } from 'react-cookie';

import axiosInterceptor from 'api/interceptor/axiosClient';

export const getDeleteById = async (info: { trapId: number; level: number }) => {
  const cookies = new Cookies();
  const token = cookies.get('local_access_token');
  const data = await axiosInterceptor.put(
    `/trap_delete/${info.trapId}/`,
    {
      level: info.level,
    },
    {
      headers: {
        Authorization: token,
      },
    },
  );
  return data.data as any;
};
